import { cookie} from '@/assets/js/utils'
import native from '@/assets/js/native'
import native_zh from '@/assets/js/native_zh'
// 中银
function isLogin () {
    return new Promise((resolve, reject) => {
        try {
            let timeout = setTimeout(() => {
                reject('没有获取到登录状态')
            }, 2000)

            
            native && native.emit('isLogin', {}, res => {
                clearTimeout(timeout)
                resolve(res)
            })
        } catch (err) {
            reject(err)
        }
    })
}
// 中行
function isRunInZh() {
    let isIos = native_zh && native_zh.ua() === "ios";
    if (isIos) {
        return (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.getUserInfo
        );
    }
    return window.jsObj && window.jsObj.getUserInfo;
}

// 微信
function isWeiXin(){
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        return true;
    }else{
        return false;
    }
}

async function appENV(){
    //如果已经存在此值不再重复判断
    let fp = cookie.get('fromPlat');
    if(fp&&!isNaN(fp)){
        return parseInt(fp);
    }

    let fromPlat = 1;
    //先判断中银
    let zhongyin = await isLogin().catch(err => {
        // console.log(err)
    });
    if(zhongyin !== undefined){
        fromPlat = 3;
    }else if(isRunInZh()){//再判断中行
        fromPlat = 2;
    }else if(isWeiXin()){//再判断微信
        fromPlat = 1;
    }
    
    cookie.set('fromPlat', fromPlat, 1)
    // console.log(fromPlat)
    return fromPlat;
}

export default appENV();